<div class="p-3 pb-10">
  <app-pan-card>
    <div class="flex h-full">
      <div class="flex pr-4 border-r-2 border-primary">
        <div class="flex-1 flex flex-col gap-1">
          @for (vm of allViewModes; track $index) {
            <app-pan-button
              [icon]="vm.icon"
              [matTooltip]="vm.tooltip"
              [matTooltipPosition]="'right'"
              [fill]="viewMode() === vm.mode ? 'filled' : 'outline'"
              (click)="changeViewMode(vm.mode)"
              panRole
              [roles]="vm.roles"
              color="primary"
            ></app-pan-button>
          }
        </div>
      </div>

      <div class="flex-1">
        @switch (viewMode()) {
          @case ("branches") {
            <app-admin-user-management-branch></app-admin-user-management-branch>
          }
          @case ("userbranches") {
            <app-admin-user-management-userbranches></app-admin-user-management-userbranches>
          }
          @case ("userlocations") {
            <app-admin-user-management-userlocations></app-admin-user-management-userlocations>
          }
          @case ("locations") {
            <app-admin-user-management-location></app-admin-user-management-location>
          }
          @case ("users") {
            <app-admin-user-management-users></app-admin-user-management-users>
          }
          @case ("locationgroupswhitelist") {
            <app-admin-user-management-location-groups-whitelist></app-admin-user-management-location-groups-whitelist>
          }
          @case ("locationdomainwhitelist") {
            <app-admin-user-management-location-domains-whitelist></app-admin-user-management-location-domains-whitelist>
          }
        }
      </div>
    </div>
  </app-pan-card>
</div>
